export default __webpack_public_path__ + "static/media/misc-closetA-480w.c11574f7.webp";